export const CHALLENGE_RATING_DEFINITION_NOT_MEETS = 'not_meets';
export const CHALLENGE_RATING_DEFINITION_PARTIALLY = 'partially';
export const CHALLENGE_RATING_DEFINITION_MEETS = 'meets';
export const CHALLENGE_RATING_DEFINITION_EXCEEDS = 'exceeds';

export const CHALLENGE_RATING_DEFINITIONS = {
    [CHALLENGE_RATING_DEFINITION_NOT_MEETS]: 'Not Met',
    [CHALLENGE_RATING_DEFINITION_PARTIALLY]: 'Nearly Met',
    [CHALLENGE_RATING_DEFINITION_MEETS]: 'Met',
    [CHALLENGE_RATING_DEFINITION_EXCEEDS]: 'Exceeded'
};
export const CHALLENGE_RATING_DEFINITION_THRESHOLDS = {
    [CHALLENGE_RATING_DEFINITION_NOT_MEETS]: {
        min: 0,
        max: 44
    },
    [CHALLENGE_RATING_DEFINITION_PARTIALLY]: {
        min: 44,
        max: 60
    },
    [CHALLENGE_RATING_DEFINITION_MEETS]: {
        min: 60,
        max: 73
    },
    [CHALLENGE_RATING_DEFINITION_EXCEEDS]: {
        min: 73,
        max: 100
    }
}
